import {EventEmitter} from '@angular/core';
import {CrudActivity} from '../../../../activity-log/data/crudActivity';

export class CrudEvents {
  create: EventEmitter<CrudActivity> = new EventEmitter<CrudActivity>();
  update: EventEmitter<CrudActivity> = new EventEmitter<CrudActivity>();
  delete: EventEmitter<CrudActivity> = new EventEmitter<CrudActivity>();
}
